export enum Colors {
    CONTENT_BACKGROUND = "#fff",
    GRAY_10 = "#d4d4d4",
    GRAY_115 = "#737578",
    GRAY_120 = "#323232",
    BLACK = "#000000",
    RED = "#FF0000",
    YELLOW = "#F59302",
    GREEN = "#1c632f",
}
